const Links = () => {
    return(
        <>
            <br />
            <div className="min-width">
                <div className="container">
                    <div className="row">
                        <div className="col m12 l12">
                            <div className="card grey darken-3">
                                <div className="card-content white-text">
                                    <span className="card-title">Links to Research Papers</span>
                                </div>
                                <div className="card-action">
                                    <a className="links_url" href="https://arxiv.org/list/hep-th/new" target="_blank" rel="noopener noreferrer">Arxiv HEP-TH</a>
                                    <a className="links_url" href="https://inspirehep.net/?ln=en" target="_blank" rel="noopener noreferrer">Inspire HEP</a>
                                </div>
                            </div>
                        </div>
                        <div className="col m12 l12">
                            <div className="card grey darken-3">
                                <div className="card-content white-text">
                                    <span className="card-title">String Related Websites</span>
                                </div>
                                <div className="card-action">
                                    <a className="links_url" href="https://www.stringwiki.org/wiki/String_Theory_Wiki" target="_blank" rel="noopener noreferrer">String Theory Wiki</a>
                                    <a className="links_url" href="https://ncatlab.org/nlab/show/string+theory" target="_blank" rel="noopener noreferrer">nLab</a>
                                </div>
                            </div>
                        </div>
                        <div className="col m12 l12">
                            <div className="card grey darken-3">
                                <div className="card-content white-text">
                                    <span className="card-title">Career Related Websites</span>
                                </div>
                                <div className="card-action">
                                    <a className="links_url" href="https://academicjobsonline.org/ajo" target="_blank" rel="noopener noreferrer">Academic Jobs Online</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Links;